/* Fiome theme shell — mobile menu + sticky CTA. Cart is handled by Recharge Storefront Experiences. */
(function () {
  'use strict';
  var body = document.body;

  document.addEventListener('click', function (e) {
    if (e.target.closest('#menuBtn')) { body.classList.add('menu-open'); return; }
    if (e.target.closest('#menuClose') || e.target.id === 'menuScrim') { body.classList.remove('menu-open'); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') body.classList.remove('menu-open'); });

  var homeSticky = document.getElementById('homeSticky');
  if (homeSticky) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 700) homeSticky.classList.add('show'); else homeSticky.classList.remove('show');
    }, { passive: true });
  }
})();
